import { render, staticRenderFns } from "./momentoBavaros.vue?vue&type=template&id=14409088&scoped=true&"
import script from "./momentoBavaros.vue?vue&type=script&lang=js&"
export * from "./momentoBavaros.vue?vue&type=script&lang=js&"
import style0 from "./momentoBavaros.vue?vue&type=style&index=0&id=14409088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14409088",
  null
  
)

export default component.exports